import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import * as debug from 'debug';
import moment from 'moment';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { UserProvider } from '../../providers/user/user';
import { EnvVariables } from '../../environments/environment';
import { ToolsProvider } from '../../providers/tools/tools';

@Component({
  selector: 'job-carousel',
  templateUrl: 'job-carousel.html',
})
export class JobCarouselComponent {
  log = debug('app:JobCarouselComponent');

  jobs: any[] = [];
  currentJobCard: any = 0;
  jobCardsArray: any[] = [];
  jobCardsSections: any[] = [];
  currentSection: any = 0;
  loadingJobs: boolean = false;
  tagString: string = '';
  totalScrollSections = 4;
  scrollSectionsSet = false;

  //number of jobs we grab and condense from
  jobQueryLimit: number = 25;

  @Input()
  displayAmount: number = 5;

  @Input()
  displayVariant: string = 'feed';

  windowWidth = window.innerWidth;

  exploreCardWidth = this.windowWidth - 32;

  constructor(
    public user: UserProvider,
    public env: EnvVariables,
    public crudApi: CrudApiProvider,
    public tools: ToolsProvider
  ) {}

  ngOnInit() {
    this.loadJobs();
    this.handleInitialScrollSections();
  }

  private loadJobs() {
    this.loadingJobs = true;
    let seenJobs = this.handleSeenJobs();
    let jobQuery = this.setUpJobQuery(seenJobs);
    this.crudApi
      .get(`${this.env.dedicatedJobsUrl}/api/job-ads`, jobQuery)
      .then(res => {
        try {
          if (res.data) {
            let jobsArray = res.data;
            //want the jobs with highlights to show first

            this.jobs = _.filter(jobsArray, j => {
              if (!_.includes(seenJobs, j._id)) {
                return _.size(_.get(j, 'computedAds.prettyHighlights'));
              }
            }).slice(0, this.displayAmount);

            //if we still need more after grabbing all the ones with highlights
            if (this.jobs.length < this.displayAmount) {
              _.each(jobsArray, j => {
                if (
                  this.jobs.length < this.displayAmount &&
                  !_.find(this.jobs, { _id: j._id })
                ) {
                  this.jobs.push(j);
                }
              });
            }

            _.each(this.jobs, j => {
              seenJobs[j._id] = new Date();
            });

            localStorage.setItem(
              'JOB_CAROUSEL_SEEN_JOBS',
              JSON.stringify(seenJobs)
            );
          }
          this.loadingJobs = false;
        } catch (e) {
          console.error(e);
        }
      });
  }

  private onScroll(event) {
    let jobsCardContainer =
      this.displayVariant === 'feed'
        ? document.getElementById('jobsCardContainer-feed')
        : document.getElementById('jobsCardContainer-explore');
    let jobsCardContainerWidth;
    let sectionWidth;
    let scrollLeft;

    //only set the scroll section vars once
    if (!this.scrollSectionsSet) {
      this.jobCardsSections = [];
      jobsCardContainerWidth = jobsCardContainer.scrollWidth;
      sectionWidth = jobsCardContainerWidth / this.totalScrollSections;
      for (let i = 1; i <= this.totalScrollSections; i++) {
        let rightOfSection = i * sectionWidth;
        let leftOfSection = rightOfSection - sectionWidth;
        this.jobCardsSections.push({
          right: rightOfSection,
          left: leftOfSection,
        });
      }
      this.scrollSectionsSet = true;
    }

    if (this.scrollSectionsSet) {
      _.each(this.jobCardsSections, (s, i) => {
        scrollLeft = jobsCardContainer.scrollLeft;
        if (s.left < scrollLeft && s.right > scrollLeft) {
          this.currentSection = i;
        }
      });
    }
  }

  goToJobLanding(id) {
    if (id) {
      let url = `https://landing.cdllife.com/job/${id}`;
      this.tools.openExternalUrl(url, 'external', {
        rt: 'mobileApp',
        utm_source: 'cbo-cdllife-mobileApp',
        utm_campaign: `job-swipe`,
      });
    }
  }

  setTagStringSeperator(i, array) {
    if (i < array.length - 1) {
      return true;
    } else {
      return false;
    }
  }

  setTagString(array) {
    return (array || []).join(' • ');
  }

  handleDriverType(userData) {
    let soloOrTeam, companyOrOwner;
    if (_.get(userData, 'soloOrTeam') === 'soloDriver') {
      soloOrTeam = 'solo';
    }
    if (_.get(userData, 'soloOrTeam') === 'teamDriver') {
      soloOrTeam = 'team';
    }
    if (_.get(userData, 'companyOrOwner') === 'ownerOperator') {
      companyOrOwner = 'Owner';
    }
    if (_.get(userData, 'companyOrOwner') === 'leasePurchase') {
      companyOrOwner = 'Lease';
    }
    if (_.get(userData, 'companyOrOwner') === 'companyDriver') {
      companyOrOwner = 'Company';
    }

    if (soloOrTeam && companyOrOwner) {
      return soloOrTeam + companyOrOwner;
    }
  }

  setUpJobQuery(seenJobs) {
    let jobSearchInfo =
        (this.user && this.user.info && this.user.info.jobSearchInfo) || null,
      jobQuery;

    if (seenJobs.length) {
      jobQuery = {
        limit: this.jobQueryLimit,
        _id: { $nin: _.keys(seenJobs) || [] },
      };
    } else {
      jobQuery = {
        limit: this.jobQueryLimit,
      };
    }

    // TODO - eventually we should add a reverse filter here to show jobs that have
    // these trailerTypes and endorsements as well as job ads that don't require
    // anything specific
    // if (jobSearchInfo.trailerTypes) {
    //   jobQuery.trailerType = jobSearchInfo.trailerTypes;
    // }
    // if (jobSearchInfo.endorsements) {
    //   jobQuery.endorsements = [];
    //   _.each(jobSearchInfo.endorsements, e => {
    //     jobQuery.endorsements.push({ [e]: true });
    //   });
    // }

    if (jobSearchInfo && jobSearchInfo.experience) {
      jobQuery.experience = jobSearchInfo.experience;
    }

    let driverType = this.handleDriverType(jobSearchInfo);

    if (driverType) {
      jobQuery.driverType = driverType;
    }

    return jobQuery;
  }

  handleSeenJobs() {
    let seenJobs =
      JSON.parse(localStorage.getItem('JOB_CAROUSEL_SEEN_JOBS')) || {};
    let oneMonthAgo = moment().subtract(1, 'month');
    for (let job in seenJobs) {
      let lastSeen = moment(seenJobs[job]);
      if (lastSeen.isBefore(oneMonthAgo)) {
        delete seenJobs[job];
      }
    }

    return seenJobs;
  }

  //faking the initial setup - just need the dots to display
  handleInitialScrollSections() {
    for (let i = 1; i <= this.totalScrollSections; i++) {
      this.jobCardsSections.push({});
    }
  }

  openJobs() {
    this.tools.openJobs(this.user.get('_id'), 'job-carousel');
  }
}



// WEBPACK FOOTER //
// ./src/components/job-carousel/job-carousel.ts